import { connect } from 'react-redux';

import { closeEditor, hasInitialized, initializeEditor } from '../utils/editor';
import { EDITOR_NAME } from './connect-editor';
import UpdateQuote from './UpdateQuote';

export default connect(
  state => ({
    initialized: hasInitialized(state, EDITOR_NAME),
    modified: !!state.changeGuard,
  }),
  {
    onInitialData: initializeEditor.bind(null, EDITOR_NAME),
    onClose: closeEditor.bind(null, EDITOR_NAME),
  },
)(UpdateQuote);
